import TPEAction from "src/models/common/TPEAction";
import { SegmentTablesState } from "src/services/segment-cdt/SegmentTablesState";

export const ACTIONS = Object.freeze({
    // Bumped to re-run the list fetch (e.g. after a Create in a later CR). Consumers dispatch
    // REFRESH; the list view keys its request off refreshToken so a new fetch fires.
    REFRESH: new TPEAction("REFRESH"),
});

export function segmentTablesReducer(state: SegmentTablesState, action: TPEAction): SegmentTablesState {
    switch (action.type) {
        case ACTIONS.REFRESH.type:
            return { ...state, refreshToken: state.refreshToken + 1 };
        default:
            console.warn(`No action found for ${action.type}. Returning unchanged state`);
            return state;
    }
}
